// Troca rápida, no mesmo aparelho, entre a leitura da pulseira do paciente e a validação
// facial da equipe. A escolha fica salva no aparelho.
import { ScanFace, ScanLine } from "lucide-react";

export type DeviceMode = "wristband" | "face";

const MODE_KEY = "cccontrol_device_mode";

export function readDeviceMode(): DeviceMode {
  try {
    return globalThis.localStorage?.getItem(MODE_KEY) === "face" ? "face" : "wristband";
  } catch {
    return "wristband";
  }
}

export function storeDeviceMode(mode: DeviceMode): void {
  try {
    globalThis.localStorage?.setItem(MODE_KEY, mode);
  } catch {
    // Storage bloqueado: a troca vale só nesta aba.
  }
}

export function ModeSwitch({ mode, onChange }: { mode: DeviceMode; onChange: (mode: DeviceMode) => void }) {
  return (
    <div className="mode-switch" role="tablist" aria-label="Modo do aparelho">
      <button
        type="button"
        role="tab"
        aria-selected={mode === "wristband"}
        className={mode === "wristband" ? "active" : undefined}
        onClick={() => onChange("wristband")}
      >
        <ScanLine aria-hidden="true" size={22} />
        <span>
          <strong>Pulseira do paciente</strong>
          <small>Entrada e saída da sala</small>
        </span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "face"}
        className={mode === "face" ? "active" : undefined}
        onClick={() => onChange("face")}
      >
        <ScanFace aria-hidden="true" size={22} />
        <span>
          <strong>Validação facial</strong>
          <small>Entrada e saída da equipe</small>
        </span>
      </button>
    </div>
  );
}
